// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1cd41bb5","239":"8e8704e3","453":"170d88f5","732":"2058ddff"}[chunkId] + ".chunk.js";
};